export default {
  downloads: {
    description:
      "Software utile per la diagnostica e la programmazione delle macchine Brokk.",
    itemName: "Software",
    size: "Dimensione",
    subtitle: "Scaricare il software per le macchine Brokk."
  }
}
